/**
 * @Author:
 * @Description:
 * @DateTime: Created in 22:27 2020/10/17
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import { createBEM } from 'src/util/bem';
import './frameSideBg.less';
import Tree from 'src/types/iview/Tree';
let bem = createBEM('frame-side-bg');

@Component
export default class FrameSideBg extends Vue.Component<{ padding?: boolean }> {
    @Prop({
        type: Boolean,
        default: true
    })
    padding!: boolean;

    render(h) {
        return (
            <div class={bem()}>
                <div class={bem('wrapper')}>
                    <div class={bem('top')} />
                    <div class={bem('mid')} />
                    <div class={bem('bottom')} />
                </div>
                <div class={bem('content', {'padding': this.padding})}>{this.$slots.default}</div>
            </div>
        );
    }
}
